module.exports = __webpack_public_path__ + "static/img/background.4eb2816d.svg";